import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import { Reducer } from 'redux';
import { IServiceDraft } from './createService';

export interface IAction<T> {
  type: string;
  payload: T;
}

export interface ISelectedFilter {
  label: string,
  value: string,
}

export type TSetFilters = {
  filteredPlaces: ISelectedFilter[];
  filteredModels: ISelectedFilter[];
  filteredServiceTypes: ISelectedFilter[];
  filteredFrequencies: ISelectedFilter[];
  filteredEquipment: ISelectedFilter | null;
  filterCreatedAtStart: Date | null,
  filterCreatedAtEnd: Date | null,
  filterModifiedAtStart: Date | null,
  filterModifiedAtEnd: Date | null,
}
export interface IServiceDraftsState {
  serviceDrafts: IServiceDraft[],
  serviceDraftsCount: number,
  loadingServiceDrafts: boolean,
  loadingDelete: boolean,
  filteredPlaces: ISelectedFilter[],
  filteredEquipment: ISelectedFilter | null,
  filteredServiceTypes: ISelectedFilter[],
  filteredFrequencies: ISelectedFilter[],
  filteredModels: ISelectedFilter[],
  filterCreatedAtStart: Date | null,
  filterCreatedAtEnd: Date | null,
  filterModifiedAtStart: Date | null,
  filterModifiedAtEnd: Date | null,
  loadingEquipmentsForFilters: boolean,
  equipmentsForFilters: any[],
  deletingDraftId: string,
}

const initialState: IServiceDraftsState = {
  serviceDrafts: [],
  serviceDraftsCount: 0,
  loadingServiceDrafts: false,
  loadingDelete: false,
  filteredPlaces: [],
  filteredEquipment: null,
  filteredServiceTypes: [],
  filteredFrequencies: [],
  filteredModels: [],
  filterCreatedAtStart: null,
  filterCreatedAtEnd: null,
  filterModifiedAtStart: null,
  filterModifiedAtEnd: null,
  loadingEquipmentsForFilters: false,
  equipmentsForFilters: [],
  deletingDraftId: '',
};

const fechServiceDraftsStart = (state: IServiceDraftsState) => {
  return updateObject(state, { loadingServiceDrafts: true });
};

const fechServiceDraftsSuccess = (state: IServiceDraftsState, action: IAction<{rows: IServiceDraft[], count: number}>) => {
  return updateObject(state, { loadingServiceDrafts: false, serviceDrafts: action.payload.rows, serviceDraftsCount: action.payload.count });
};

const fechServiceDraftsFail = (state: IServiceDraftsState) => {
  return updateObject(state, { loadingServiceDrafts: false });
};

const fetchEquipmentsStart = (state: IServiceDraftsState) => {
  return updateObject(state, { loadingEquipmentsForFilters: true });
}

const fetchEquipmentsSuccess = (state: IServiceDraftsState, action: IAction<any>) => {
  return updateObject(state, { loadingEquipmentsForFilters: false, equipmentsForFilters: action.payload });
}

const fetchEquipmentsFail = (state: IServiceDraftsState) => {
  return updateObject(state, { loadingEquipmentsForFilters: false });
}

const setFilters = (state: IServiceDraftsState, action: IAction<TSetFilters>) => {
  return updateObject(state, action.payload);
}

const deleteDraftStart = (state: IServiceDraftsState, action: IAction<string>) => {
  return updateObject(state, { loadingDelete: true, deletingDraftId: action.payload });
}

const deleteDraftSuccessFail = (state: IServiceDraftsState) => {
  return updateObject(state, { loadingDelete: false, deletingDraftId: '' });
}

const clearFilters = (state: IServiceDraftsState) => {
  return updateObject(state, {
    filteredPlaces: [],
    filteredEquipment: null,
    filteredServiceTypes: [],
    filteredFrequencies: [],
    filteredModels: [],
    filterCreatedAtStart: null,
    filterCreatedAtEnd: null,
    filterModifiedAtStart: null,
    filterModifiedAtEnd: null
  });
}

const reducer: Reducer<IServiceDraftsState, IAction<any>> = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SERVICE_DRAFTS_FETCH_START: return fechServiceDraftsStart(state);
    case actionTypes.SERVICE_DRAFTS_FETCH_SUCCESS: return fechServiceDraftsSuccess(state, action);
    case actionTypes.SERVICE_DRAFTS_FETCH_FAIL: return fechServiceDraftsFail(state);

    case actionTypes.SERVICE_DRAFTS_FETCH_EQUIPMENTS_START: return fetchEquipmentsStart(state);
    case actionTypes.SERVICE_DRAFTS_FETCH_EQUIPMENTS_SUCCESS: return fetchEquipmentsSuccess(state, action);
    case actionTypes.SERVICE_DRAFTS_FETCH_EQUIPMENTS_FAIL: return fetchEquipmentsFail(state);

    case actionTypes.SERVICE_DRAFTS_SET_FILTERS: return setFilters(state, action);
    case actionTypes.SERVICE_DRAFTS_CLEAR_FILTERS: return clearFilters(state);

    case actionTypes.SERVICE_DRAFTS_DELETE_DRAFT_START: return deleteDraftStart(state, action);
    case actionTypes.SERVICE_DRAFTS_DELETE_DRAFT_SUCCESS: return deleteDraftSuccessFail(state);
    case actionTypes.SERVICE_DRAFTS_DELETE_DRAFT_FAIL: return deleteDraftSuccessFail(state);

    default: return state;
  }
};

export default reducer;
